import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { Box, xcss } from '@atlaskit/primitives';
import { getAISummaryErrorMessage } from '../../../../../../utils/ai-summary';
import AILearnMoreAnchor from '../../../common/ai-summary/ai-learn-more-anchor';
import AIIndicatorContainer from './ai-indicator-container';
var contentStyles = xcss({
  color: 'color.text.subtle',
  fontSize: '11px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '14px'
});
var FormattedErrorMessage = function FormattedErrorMessage(_ref) {
  var message = _ref.message,
    url = _ref.url;
  return /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, message, {
    values: {
      a: function a(chunks) {
        return /*#__PURE__*/React.createElement(AILearnMoreAnchor, {
          href: url
        }, chunks);
      }
    }
  }));
};
var AIStateError = function AIStateError(_ref2) {
  var appearance = _ref2.appearance,
    testId = _ref2.testId,
    error = _ref2.error;
  var _getAISummaryErrorMes = getAISummaryErrorMessage(error),
    message = _getAISummaryErrorMes.message,
    url = _getAISummaryErrorMes.url;
  switch (appearance) {
    case 'icon-only':
      return null;
    default:
      return /*#__PURE__*/React.createElement(AIIndicatorContainer, {
        icon: /*#__PURE__*/React.createElement(ErrorIcon, {
          primaryColor: "var(--ds-icon-danger, #C9372C)",
          label: "AI",
          size: "small",
          testId: "".concat(testId, "-error-icon")
        }),
        content: /*#__PURE__*/React.createElement(Box, {
          testId: "".concat(testId, "-error-message"),
          xcss: contentStyles
        }, /*#__PURE__*/React.createElement(FormattedErrorMessage, {
          message: message,
          url: url
        })),
        testId: "".concat(testId, "-error")
      });
  }
};
export default AIStateError;